/**
 * Глобальний in-app алерт (юзер 2026-06-11: «скрізь де системні tg.showAlert
 * — заміни на наш задизайнений попап»). Імперативний стор: будь-який код
 * (навіть поза React) викликає showAppAlert(...), а <AppAlert/> у корені
 * рендерить наш модал. closeAppAlert закриває.
 */
export type AppAlertButton = {
  label: string;
  /** primary = оранжева кнопка, ghost = текст, danger = червона */
  variant?: "primary" | "ghost" | "danger";
  onClick?: () => void;
};

export type AppAlertState = {
  title?: string;
  message: string;
  emoji?: string;
  buttons?: AppAlertButton[];
};

let current: AppAlertState | null = null;
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

export function showAppAlert(
  message: string,
  opts?: { title?: string; emoji?: string; buttons?: AppAlertButton[] },
): void {
  current = {
    message,
    title: opts?.title,
    emoji: opts?.emoji,
    buttons: opts?.buttons,
  };
  emit();
}

export function closeAppAlert(): void {
  current = null;
  emit();
}

export function getAppAlert(): AppAlertState | null {
  return current;
}

export function subscribeAppAlert(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
